import { defineMessages } from 'react-intl';

/** The texts that the Free row and the paid plan cards share. */
export const pricingCardMessages = defineMessages({
  currentPlan: { id: 'app.sml.pricing.badge.current', defaultMessage: 'Current plan' },
  currentPlanTrial: { id: 'app.sml.pricing.badge.currentTrial', defaultMessage: 'Current plan · Trial' },
});
